import bannerBgDefault from '../../assets/images/header-banner.png';

export default function HeroSection({ title, backgroundImage, opacity = 1, overlayColor = 'bg-black/10', rotation = '' }) {
  const bgImage = backgroundImage || bannerBgDefault;
  
  return (
    <section className="relative py-20 md:py-28 lg:py-32 overflow-hidden flex items-center justify-center bg-black">
      {/* Background Image */}
      <div
        className={`absolute inset-0 bg-cover bg-center z-0 ${rotation}`}
        style={{ 
          backgroundImage: `url(${bgImage})`,
          opacity: opacity
        }}
      />
      {/* Subtle overlay to ensure text contrast if image is too busy */}
      <div className={`absolute inset-0 z-10 ${overlayColor}`} />
      
      {/* Content */}
      <div className="container-custom text-center relative z-20">
        <h1 className="font-headline text-4xl md:text-5xl lg:text-6xl font-semibold text-chalk uppercase tracking-wider">
          {title}
        </h1>
      </div>
    </section>
  );
}
